export default "__VITE_ASSET__dOZO$8PD__"